const menu = {
  key: "webNews",
  route: "/legacy/web-news",
  label: "sidebar.webNews",
  icon: "faNewspaper",
  group: "cms",
  order: 10,
  permission: "legacy.webNews.read"
};

export default menu;